import React, { useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react"; // 引入 TinyMCE
import axiosInstance from "../AxiosInstance";
import { set } from "lodash";

const CreateArticle = ({ onArticleCreated, onCancel }) => {
  const [categories, setCategories] = useState([]); // 分类列表
  const [newArticle, setNewArticle] = useState({ title: "", content: "", categoryId: "" });
  const [newCategory, setNewCategory] = useState(""); // 新分类名称
  const [tags, setTags] = useState([]); // 标签列表
  const [selectedTags, setSelectedTags] = useState([]); // 已选择标签
  const [newTag, setNewTag] = useState(""); // 新标签名称
  const [categoryNoArticles,setCategoryNoArticles]=useState([]);

  // 获取分类和标签数据
  useEffect(() => {
    axiosInstance
      .get("/category")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error("Failed to fetch categories:", err));

    axiosInstance
      .get("/tag")
      .then((res) => setTags(res.data))
      .catch((err) => console.error("Failed to fetch tags:", err));

    axiosInstance
      .get("/category/categoryonly")
      .then((res)=>setCategoryNoArticles(res.data))
      .catch((err)=>console.error("Failed to fetch categories:",err));
  }, []);

  const handleSaveArticle = () => {
    if (!newArticle.title || (!newArticle.categoryId && !newCategory)) {
      alert("Please fill in all required fields.");
      return;
    }

    // 新建分类并保存文章
    if (newCategory) {
      axiosInstance
        .post("/categories", { name: newCategory })
        .then((res) => {
          const categoryId = res.data.id; // 新分类 ID
          saveArticleWithTags(categoryId);
        })
        .catch((err) => console.error("Failed to create category:", err));
    } else {
      saveArticleWithTags(newArticle.categoryId);
    }
  };

  const saveArticleWithTags = (categoryId) => {
    // 合并已选择的标签和新标签
    const allTags = [...selectedTags];
    if (newTag.trim()) {
      allTags.push(newTag.trim());
    }

    axiosInstance
      .post("/kbarticles/files", { title: newArticle.title, content: newArticle.content, categoryId, tags: allTags })
      .then(() => {
        alert("Article created successfully!");
        onArticleCreated(); // 通知父组件刷新数据
        resetForm();
        onCancel(); // 自动关闭创建页面
      })
      .catch((err) => console.error("Failed to create article:", err));
  };

  const resetForm = () => {
    setNewArticle({ title: "", content: "", categoryId: "" });
    setNewCategory("");
    setSelectedTags([]);
    setNewTag("");
  };

  const renderCategoryTree=(nodes)=>{
    return nodes.map((node)=>(
      <React.Fragment key={node.id}>
          <option value={node.id}>
            {node.name}
          </option>
      {node.children&&renderCategoryTree(node.children)}
      </React.Fragment>


    ));
  }

  return (
    <div style={{ padding: "20px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
      <h3>Create New Article</h3>
      <div style={{ marginBottom: "10px" }}>
        <label>Title:</label>
        <input
          type="text"
          placeholder="Enter article title"
          value={newArticle.title}
          onChange={(e) => setNewArticle({ ...newArticle, title: e.target.value })}
          style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label>Content:</label>
        <Editor
          apiKey="p3lut8e5pnk7o8f3y37ianvo09hpm2ov6gkl1jfn6nx9j1e1"
          initialValue="<p>Start writing your article here...</p>"
          value={newArticle.content}
          init={{
            height: 500,
            menubar: false,
            plugins: [
              "image",
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
            ],
            toolbar:
              "undo redo | image | formatselect | bold italic backcolor | " +
              "alignleft aligncenter alignright alignjustify | " +
              "bullist numlist outdent indent | removeformat | help",
            //image_upload_url: "/s3/files",
            paste_data_images: true,
            automatic_uploads: true,
            images_upload_handler: function (blobInfo, success, failure) {
              if (typeof failure !== "function") {
                console.error("Failure is not a function:", failure);
                return;
              }
            
              try {
                const formData = new FormData();
            
                // 将单个文件添加到 files 字段中
                formData.append("file", blobInfo.blob(), blobInfo.filename());
            
                axiosInstance
                  .post("/s3", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then((response) => {
                    if (response.data ) {
                      // 假设后端返回的是文件 URL 的数组
                      success(response.data); // 将第一个文件 URL 插入到 TinyMCE 编辑器中
                    } else {
                      failure("Invalid response format");
                    }
                  })
                  .catch((error) => {
                    console.error("Image upload failed:", error);
                    failure("Image upload failed: " + error.message);
                  });
              } catch (error) {
                console.error("Unexpected error in image upload handler:", error);
                failure("Unexpected error: " + error.message);
              }
            }
          }}
          onEditorChange={(content) => setNewArticle({ ...newArticle, content })}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label>Select Category:</label>
        <select
          value={newArticle.categoryId}
          onChange={(e) => setNewArticle({ ...newArticle, categoryId: e.target.value })}
          style={{ width: "100%", padding: "10px" }}
        >
          <option value="">-- Select Category --</option>
          {renderCategoryTree(categoryNoArticles)}
        </select>
      </div>
      {/* <div style={{ marginBottom: "10px" }}>
        <label>Or Create New Category:</label>
        <input
          type="text"
          placeholder="Enter new category name"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          style={{ width: "100%", padding: "10px" }}
        />
      </div> */}
      <div style={{ marginBottom: "10px" }}>
  <label>Tags:</label>
  <div className="tag-cloud">
    {tags.map((tag) => (
      <span
        key={tag.id}
        className={`tag ${selectedTags.includes(tag.name) ? "selected" : ""}`}
        onClick={() => {
          if (selectedTags.includes(tag.name)) {
            setSelectedTags(selectedTags.filter((t) => t !== tag.name)); // 取消选择
          } else {
            setSelectedTags([...selectedTags, tag.name]); // 添加选择
          }
        }}
      >
        {tag.name}
      </span>
    ))}

    {selectedTags 
      .filter((tag)=>!tags.some((t)=>t.name===tag))
      .map((tag,index)=>(
        <span
          key={`new-tag-${index}`}
          className="tag selected"
          onClick={()=>{
            setSelectedTags(selectedTags.filter((t)=>t!==tag));
          }}>
            {tag}
          </span>
      ))}
  </div>
</div>
      <div style={{marginBottom:"40px"}}>
        <label>Or Create New Tags</label>
        <input
          type="text"
          placeholder="Enter New tags and press Enter"
          value={newTag}
          onChange={(e)=>setNewTag(e.target.value)}
          onKeyDown={(e)=>{
            if(e.key==="Enter"&& newTag.trim()!==""){
              if(!selectedTags.includes(newTag)){
                setSelectedTags([...selectedTags,newTag]);
              }
              setNewTag("");
              e.preventDefault();
            }
          }}
          style={{with:"100%",padding:"10px"}}/>

      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={handleSaveArticle}
          style={{ padding: "10px 20px", backgroundColor: "green", color: "#fff", border: "none", cursor: "pointer" }}
        >
          Save
        </button>
        <button
          onClick={onCancel}
          style={{ padding: "10px 20px", backgroundColor: "red", color: "#fff", border: "none", cursor: "pointer" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default CreateArticle;
